var $c70a61b395f82fe4$exports = {};
const $c70a61b395f82fe4$var$mainInput = document.querySelectorAll("fieldset#mark-setting input");
const $c70a61b395f82fe4$var$title = document.querySelector("nav ul li strong");
const $c70a61b395f82fe4$var$canvas = document.getElementById("canvas");
const $c70a61b395f82fe4$var$ctx = $c70a61b395f82fe4$var$canvas.getContext("2d");
const $c70a61b395f82fe4$var$actionBtn = document.querySelector("#action");
const $c70a61b395f82fe4$var$image_upload = document.querySelector("#raw-img");
const $c70a61b395f82fe4$var$nav_tip = document.querySelector("nav ul li small");
let $c70a61b395f82fe4$var$maxSize;
let $c70a61b395f82fe4$var$imgName;
let $c70a61b395f82fe4$var$imgSize;
let $c70a61b395f82fe4$var$imgType;
const $c70a61b395f82fe4$var$inputCB = (checked = false)=>{
    const start = Date.now();
    for (const x of $c70a61b395f82fe4$var$mainInput){
        const span = document.getElementById(x.id + "-span");
        if (span && span.innerHTML != x.value) span.innerHTML = x.value;
    }
    if (!checked) return;
    if (!document.getElementById("upload").files.length) {
        console.log("\u672A\u9009\u62E9\u6587\u4EF6");
        return;
    } else {
        $c70a61b395f82fe4$var$actionBtn.disabled = false;
        $c70a61b395f82fe4$var$actionBtn.setAttribute("aria-busy", true);
        const formatName = document.querySelector("input[name='format'][checked]").id;
        const file = document.getElementById("upload").files[0];
        const upload = window.URL.createObjectURL(file);
        $c70a61b395f82fe4$var$imgName = file.name;
        $c70a61b395f82fe4$var$imgSize = file.size;
        $c70a61b395f82fe4$var$imgType = file.type;
        $c70a61b395f82fe4$var$image_upload.src = upload;
        $c70a61b395f82fe4$var$image_upload.onload = ()=>{
            $c70a61b395f82fe4$var$draw();
            $c70a61b395f82fe4$var$can2jpg($c70a61b395f82fe4$var$canvas, formatName);
            $c70a61b395f82fe4$var$showInfo(formatName);
            $c70a61b395f82fe4$var$actionBtn.setAttribute("aria-busy", false);
            const cost = Date.now() - start;
            $c70a61b395f82fe4$var$nav_tip.textContent = `${cost} ms`;
            console.info("finished", cost);
        };
    }
};
const $c70a61b395f82fe4$var$showInfo = (formatName)=>{
    const rInfo = document.querySelector("#raw-info");
    const pInfo = document.querySelector("#preview-info");
    rInfo.innerHTML = `type: ${$c70a61b395f82fe4$var$imgType}<br>size: ${$c70a61b395f82fe4$var$imgSize}`;
    pInfo.textContent = `type: ${formatName}`;
};
const $c70a61b395f82fe4$var$draw = ()=>{
    $c70a61b395f82fe4$var$canvas.width = $c70a61b395f82fe4$var$image_upload.width;
    $c70a61b395f82fe4$var$canvas.height = $c70a61b395f82fe4$var$image_upload.height;
    $c70a61b395f82fe4$var$maxSize = Math.max($c70a61b395f82fe4$var$image_upload.height, $c70a61b395f82fe4$var$image_upload.width);
    $c70a61b395f82fe4$var$canvas.style.height = $c70a61b395f82fe4$var$image_upload.height / $c70a61b395f82fe4$var$image_upload.width * 100 + "%";
    $c70a61b395f82fe4$var$ctx.restore();
    $c70a61b395f82fe4$var$ctx.drawImage($c70a61b395f82fe4$var$image_upload, 0, 0, $c70a61b395f82fe4$var$canvas.width, $c70a61b395f82fe4$var$canvas.height);
    $c70a61b395f82fe4$var$ctx.fillStyle = document.getElementById("color").value;
    $c70a61b395f82fe4$var$ctx.globalAlpha = document.getElementById("alpha").value / 100;
    const size = document.getElementById("size").value * $c70a61b395f82fe4$var$maxSize / 100;
    $c70a61b395f82fe4$var$ctx.font = size + 'px "' + document.getElementById("font").value + '"';
    $c70a61b395f82fe4$var$ctx.textBaseline = "middle";
    const rot = document.getElementById("rotate").value;
    $c70a61b395f82fe4$var$ctx.rotate(rot * Math.PI / 180);
    const gap = size * document.getElementById("gap").value / 100;
    const content = document.getElementById("content").value;
    if (!content.length) return;
    const limit = Math.sqrt(2 * ($c70a61b395f82fe4$var$maxSize * $c70a61b395f82fe4$var$maxSize));
    const breaker = $c70a61b395f82fe4$var$ctx.measureText(content).width;
    for(let h = -$c70a61b395f82fe4$var$maxSize, even = false; h <= limit; h += size + gap, even = !even)for(let v = -$c70a61b395f82fe4$var$maxSize - (even ? breaker / 2 : 0); v <= limit + (even ? breaker / 2 : 0); v += breaker + size)$c70a61b395f82fe4$var$ctx.fillText(content, v, h);
};
const $c70a61b395f82fe4$var$can2jpg = (canvas, formatName)=>{
    canvas.toBlob((blob)=>{
        const url = URL.createObjectURL(blob);
        const previewImg = document.getElementById("preview-img");
        // const downloadBtn = document.getElementById("download");
        previewImg.src = url;
        previewImg.alt = $c70a61b395f82fe4$var$imgName;
        previewImg.style = null;
        $c70a61b395f82fe4$var$image_upload.style = null;
    // downloadBtn.disabled = false;
    }, `image/${formatName}`, 1);
};
try {
    const live = document.querySelector("#live");
    document.querySelectorAll("input").forEach((input)=>{
        input.onchange = function(ev) {
            $c70a61b395f82fe4$var$inputCB(live.checked);
        };
    });
    $c70a61b395f82fe4$var$actionBtn.addEventListener("click", ()=>{
        $c70a61b395f82fe4$var$inputCB(true);
    });
    document.querySelectorAll("#mark-setting label").forEach((label)=>{
        const input = label.querySelector("input");
        const node = document.createElement("span");
        node.textContent = input.value;
        node.id = input.id + "-span";
        label.insertBefore(node, input);
    });
    const checkedFix = ()=>{
        formatInput.forEach((elem)=>{
            if (elem.checked) elem.setAttribute("checked", true);
            else elem.removeAttribute("checked");
        });
    };
    const formatInput = document.querySelectorAll("input[name='format']");
    formatInput.forEach((elem)=>{
        elem.addEventListener("click", checkedFix);
    });
    // document.querySelector("#download").addEventListener("click", () => {
    //   const img = document.getElementById("preview-img");
    //   const aNode = document.createElement("a");
    //   aNode.href = img.href;
    //   aNode.alt = imgName;
    //   aNode.download = document.title + " - " + imgName;
    //   aNode.click();
    // });
    $c70a61b395f82fe4$var$title.textContent = document.title;
    $c70a61b395f82fe4$var$title.addEventListener("click", ()=>{
        window.location.replace("");
    });
} catch (err) {
    $c70a61b395f82fe4$var$title.textContent = "\u52A0\u8F7D\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5";
    console.error(err);
} finally{
    $c70a61b395f82fe4$var$title.setAttribute("aria-busy", false);
}


//# sourceMappingURL=index.99180bf9.js.map
